import styled from "styled-components"
import { BaseInput } from "../base-input/BaseInput"

export const TextInput = styled(BaseInput)``
